import { render, staticRenderFns } from "./MaterialsAdmin.vue?vue&type=template&id=375c5b61&"
import script from "./MaterialsAdmin.vue?vue&type=script&lang=js&"
export * from "./MaterialsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports